import { StrictMode } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router';
import routes from './routes';
import * as ReactDOM from 'react-dom/client';
import { SessionProvider } from '@mono/auth-react';
import { Provider } from '@mono/chakra';
import {
  HttpProvider,
  QueryClient,
  QueryClientProvider,
} from '@mono/http-hook';

const browserRoutes = createBrowserRouter(routes);
const queryClient = new QueryClient();

ReactDOM.createRoot(document).render(
  <StrictMode>
    <HttpProvider>
      <QueryClientProvider client={queryClient}>
        <Provider>
          <SessionProvider>
            <RouterProvider router={browserRoutes} />
          </SessionProvider>
        </Provider>
      </QueryClientProvider>
    </HttpProvider>
  </StrictMode>
);
